import {
  DocumentData,
  QueryDocumentSnapshot,
  collection,
  getCountFromServer,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
} from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import UserHistory from '../../models/user_doc/UserHistory';

/**
 * Fetches paginated user history from the Users/{userId}/history subcollection.
 */
async function getUserHistory(
  userUid: string,
  pageSize: number,
  lastVisible?: QueryDocumentSnapshot<DocumentData, DocumentData>
): Promise<{
  items: UserHistory[];
  lastVisible: QueryDocumentSnapshot<DocumentData, DocumentData> | undefined;
  totalCount: number;
}> {
  try {
    const db = firestore;
    const historyCollection = collection(
      db,
      FirestoreCollections.users,
      userUid,
      FirestoreCollections.users_history
    );

    const historyQuery = lastVisible
      ? query(
          historyCollection,
          orderBy('timestamp', 'desc'),
          startAfter(lastVisible),
          limit(pageSize)
        )
      : query(
          historyCollection,
          orderBy('timestamp', 'desc'),
          limit(pageSize)
        );

    const results = await getDocs(historyQuery);
    const items = results.docs.map((doc) => UserHistory.fromFirestore(doc));

    const countSnapshot = await getCountFromServer(historyCollection);
    const totalCount = countSnapshot.data().count ?? 0;

    const lastDoc = results.docs[results.docs.length - 1];
    return {
      items,
      lastVisible: lastDoc,
      totalCount,
    };
  } catch (e) {
    console.error('getUserHistory error:', e);
    throw new GetUserHistoryFailure();
  }
}

export class GetUserHistoryFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getUserHistory;
